/** Admin: attendant detail (locations, roles, pay, deactivate) for one owner. */
import React from 'react';
import { useLocalSearchParams } from 'expo-router';
import { OwnerScopeProvider } from '../../../../../src/context/OwnerScopeContext';
import AttendantDetailScreen from '../../../../owner/staff/[id]';

export default function AdminOwnerAttendantDetailScreen() {
  const { id, attendantId } = useLocalSearchParams<{ id: string; attendantId: string }>();
  return (
    <OwnerScopeProvider ownerId={id}>
      <AttendantDetailScreen entityId={attendantId} />
    </OwnerScopeProvider>
  );
}
